import { AfterContentInit, Component, OnChanges, Input, OnDestroy, OnInit, QueryList, TemplateRef, SimpleChanges, Renderer2, ChangeDetectorRef, effect, signal, Signal, WritableSignal, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { animate, style, transition, trigger } from '@angular/animations';
import { CxTableService } from '../services/cx-table.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { GridMode } from '../types/gridmode';
import { SideBarTypes } from '../types/sidebar';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'cx-datagrid-settings',
  templateUrl: './cx-datagrid-settings.component.html',
  styleUrl: './cx-datagrid-settings.component.scss',
})
export class CxDatagridSettingsComponent implements OnChanges {
  @Output() close = new EventEmitter();
  @Output() mode = new EventEmitter();
  @Output() export = new EventEmitter();
  @Output() save = new EventEmitter();

  @Input() columns: any[] = [];
  @Input() views: any[] = [];
  @Input() module: string = '';
  @Input() showCardView: boolean = false;
  @Input() showExport: boolean = true;
  @Input() sideBarType = SideBarTypes.Columns;
  @Input() moreOptions = {
    label: '',
    directComponentRender: false,
    showFrozenOption: true,
    saveConfig: false,
  };
  initialColumnsState = '';
  hasChanges: boolean = false;
  SideBarTypes = SideBarTypes;

  selection: any[] = [];
  freeze: any[] = [];
  unfreeze: any[] = [];
  currentTab = 'grid';
  GridMode = GridMode;
  gridOptions = [
    { name: 'Grid', value: GridMode.Grid },
    { name: 'List', value: GridMode.List },
  ];
  constructor(public tableService: CxTableService, private toastService: ToastService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sideBarType']) {
      if (SideBarTypes.Columns == changes['sideBarType'].currentValue) {
        this.currentTab = 'grid';
      } else if (SideBarTypes.Schedular == changes['sideBarType'].currentValue) {
        this.currentTab = 'schedular';
      } else if (SideBarTypes.Exports == changes['sideBarType'].currentValue) {
        this.currentTab = 'export';
      }
    }

    if (changes['columns']) {
      if (this.moreOptions.directComponentRender) {
        this.tableService.columns = changes['columns'].currentValue.filter((x: any) => x.display == true);
      }
      this.initialColumnsState = JSON.stringify(this.tableService.columns);
      this.selection = this.tableService.columns.filter((x) => x.selection);
      this.freeze = this.tableService.columns.filter((x) => x.frozen && !x.selection);
      this.unfreeze = this.tableService.columns.filter((x) => !x.frozen && !x.selection);
    }
  }

  onClose(e: MouseEvent) {
    e.preventDefault();
    this.close.emit('');
  }

  onSave(e: MouseEvent) {
    e.preventDefault();
    this.save.emit(this.tableService.columns);
    this.hasChanges = false;
    this.initialColumnsState = JSON.stringify(this.tableService.columns);
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer.id === event.container.id) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      if (event.container.id === 'freeze' && this.freeze.length === 3) {
        this.toastService.info('Only three columns are allowed to freeze');
        return;
      } else if (!event.item.data.viewable) {
        this.toastService.info('Only selected columns can be moved');
        return;
      }
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }

    this.tableService.columns = [
      ...this.selection,
      ...this.freeze.map((x) => {
        x.frozen = true;
        return x;
      }),
      ...this.unfreeze.map((x) => {
        x.frozen = false;
        return x;
      }),
    ];

    this.freeze = this.tableService.columns.filter((x) => x.frozen && !x.selection);
    this.unfreeze = this.tableService.columns.filter((x) => !x.frozen && !x.selection);

    this.tableService.setRandom();
    this.checkForChanges();
  }

    onChange(column: any, value: any) {
        column.viewable = value;
        this.tableService.columns = [...this.tableService.columns];

        this.freeze = this.tableService.columns.filter((x) => x.frozen && !x.selection);
        this.unfreeze = this.tableService.columns.filter((x) => !x.frozen && !x.selection);

        this.tableService.setRandom();
        this.checkForChanges();
    }
  checkForChanges() {
    if(this.moreOptions.saveConfig){
        this.hasChanges = this.initialColumnsState !== JSON.stringify(this.tableService.columns);
    }
  }
  canDropOnFreezeArea(e: any) {
    return this.freeze.length < 4;
  }

  onModeChange($event: any) {
    this.mode.emit($event);
    // this.tableService.setRandom();
  }

  onExport($event: any) {
    this.export.emit($event);
  }
}
